module.exports = __webpack_public_path__ + "static/media/close-black.281cd552.svg";